import { Controller } from '@hotwired/stimulus'

// Submits the Netlify contact form over AJAX so we can swap in an inline
// success message instead of redirecting to Netlify's generic success page.
// See https://docs.netlify.com/manage/forms/setup/#submit-html-forms-with-ajax
export default class extends Controller {
  static targets = ['form', 'formContainer', 'success', 'error', 'submit']

  submit(event) {
    event.preventDefault()

    const formData = new FormData(this.formTarget)

    this.#setSubmitting(true)
    if (this.hasErrorTarget) this.errorTarget.classList.add('hidden')

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString(),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed: ${response.status}`)
        this.#showSuccess()
      })
      .catch(() => {
        this.#setSubmitting(false)
        if (this.hasErrorTarget) this.errorTarget.classList.remove('hidden')
      })
  }

  #showSuccess() {
    this.formContainerTarget.classList.add('hidden')
    this.successTarget.classList.remove('hidden')
    this.successTarget.focus()
  }

  #setSubmitting(isSubmitting) {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = isSubmitting
    this.submitTarget.classList.toggle('opacity-60', isSubmitting)
    this.submitTarget.classList.toggle('cursor-not-allowed', isSubmitting)
    if (isSubmitting) {
      this.submitTarget.dataset.originalLabel = this.submitTarget.textContent
      this.submitTarget.textContent = 'Sending…'
    } else if (this.submitTarget.dataset.originalLabel) {
      this.submitTarget.textContent = this.submitTarget.dataset.originalLabel
    }
  }
}
